module.exports = __webpack_public_path__ + "media/instaBioExample.c881aaeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instaBioExample.png
// module id = ./src/assets/instaBioExample.png
// module chunks = 0